<template>
  <div class="error-page">
    <AntProvider :theme="theme" :configProviderProps="{ locale: locale }">
      <div class="content">
        <Resource
          :src="
            getFeUrl(
              isChinese()
                ? '/youyan-platform/png/no-data.png'
                : '/rendora/404.png'
            )
          "
          :transform-resource="transformImage"
          class="mx-auto"
          :class="isChinese() ? 'w-[200px] h-[200px]' : 'w-[944px] h-[321px]'"
        />
        <div
          class="text-font-80 font-bold"
          :class="
            isChinese()
              ? 'text-[18px] my-[30px]'
              : 'text-[30px] mt-[15px] mb-[24px]'
          "
        >
          {{ $t('dang-qian-ye-mian-bu-cun-zai') }}
        </div>
        <span
          v-if="!isChinese()"
          class="w-[474px] block text-[#000] text-[17px] text-center mx-auto mb-[32px]"
        >
          The page you are looking for might have been removed had its name
          changed or is temporarily unavailabel.
        </span>
        <p class="text-text-1 mb-[32px]">
          {{ $t('n-miao-mei-fan-hui-shou-ye', [countdown]) }}
        </p>
        <a-button
          type="primary"
          :class="!isChinese() && 'w-[240px] h-[42px] rounded-[15px]'"
          @click="startToGoHome"
        >
          {{ $t('fan-hui-shou-ye') }}
        </a-button>

        <!-- 开发环境显示详细错误信息 -->
        <div
          v-if="isDev && props.error"
          class="mt-8 p-4 bg-gray-100 rounded-lg text-left max-w-4xl mx-auto"
        >
          <h3 class="text-lg font-bold mb-4 text-red-600">
            🔍 开发环境错误详情:
          </h3>
          <div class="space-y-2 text-sm">
            <div><strong>状态码:</strong> {{ props.error.statusCode }}</div>
            <div>
              <strong>状态消息:</strong> {{ props.error.statusMessage }}
            </div>
            <div><strong>错误消息:</strong> {{ props.error.message }}</div>
            <div v-if="props.error.stack" class="mt-4">
              <strong>错误堆栈:</strong>
              <pre
                class="mt-2 p-2 bg-gray-200 rounded text-xs overflow-auto max-h-40"
                >{{ props.error.stack }}</pre
              >
            </div>
          </div>
        </div>
      </div>
    </AntProvider>
  </div>
</template>
<script lang="ts" setup>
import enUS from 'ant-design-vue/es/locale/en_US'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { transformImage } from '~/utils/'
import { isChinese } from '~/utils/area'
import { getFeUrl } from '~/utils/url'
import { AntProvider } from './features/provider'

const locale = isChinese() ? zhCN : enUS

const theme = 'light'

const props = defineProps({
  error: Object,
})

// 在开发环境下显示详细错误信息
const isDev = process.env.NODE_ENV === 'development'

let interval: NodeJS.Timeout
const countdown = ref(3)

onMounted(() => {
  // 记录错误信息到控制台
  if (props.error) {
    console.error('🚨 [ERROR PAGE] 错误页面显示:', {
      statusCode: props.error.statusCode,
      statusMessage: props.error.statusMessage,
      message: props.error.message,
      stack: props.error.stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    })

    // 在开发环境下显示完整错误对象
    if (isDev) {
      console.group('🔍 [DEBUG] 完整错误信息')
      console.error('错误对象:', props.error)
      console.groupEnd()
    }
  }

  interval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      startToGoHome()
    }
  }, 1000)
})

onBeforeUnmount(() => clearInterval(interval))

function startToGoHome() {
  clearInterval(interval)
  goHome()
}
</script>
<style lang="scss" scoped>
.error-page {
  padding-top: $top-height;
  height: calc(100vh - $top-height);

  .content {
    @apply flex flex-col justify-center h-full items-center mx-auto text-center;
  }
}
</style>
